module.exports = __webpack_public_path__ + "static/img/goodsList2.22807ba2.png";